export const calculateSLA = (
  updatedAt: string,
  urgency?: "LOW" | "MEDIUM" | "HIGH" | "URGENT",
): string => {
  const lastUpdate = new Date(updatedAt);

  const slaDays: Record<string, number> = {
    URGENT: 1, // 24 horas
    HIGH: 3, // 3 dias úteis
    MEDIUM: 7, // 7 dias úteis
    LOW: 15, // 15 dias úteis
  };

  const days = slaDays[urgency || "HIGH"];

  // Adiciona os dias ao updatedAt
  const slaDate = new Date(lastUpdate);
  slaDate.setDate(slaDate.getDate() + days);

  // Formata a data
  const day = slaDate.getDate().toString().padStart(2, "0");
  const month = (slaDate.getMonth() + 1).toString().padStart(2, "0");
  const year = slaDate.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getSLADaysRemaining = (
  updatedAt: string,
  urgency?: "LOW" | "MEDIUM" | "HIGH" | "URGENT",
): { days: number; isOverdue: boolean } => {
  const lastUpdate = new Date(updatedAt);

  const slaDays: Record<string, number> = {
    URGENT: 1,
    HIGH: 3,
    MEDIUM: 7,
    LOW: 15,
  };

  const days = slaDays[urgency || "ALTA"];
  const slaDate = new Date(lastUpdate);
  slaDate.setDate(slaDate.getDate() + days);

  const now = new Date();
  const diffInMs = slaDate.getTime() - now.getTime();
  const daysRemaining = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  return {
    days: Math.abs(daysRemaining),
    isOverdue: daysRemaining < 0,
  };
};

export const getSLAStatus = (
  updatedAt: string,
  urgency?: "LOW" | "MEDIUM" | "HIGH" | "URGENT",
): "safe" | "warning" | "danger" => {
  const lastUpdate = new Date(updatedAt);

  const slaDays: Record<string, number> = {
    URGENT: 1,
    HIGH: 3,
    MEDIUM: 7,
    LOW: 15,
  };

  const totalDays = slaDays[urgency || "HIGH"];
  const slaDate = new Date(lastUpdate);
  slaDate.setDate(slaDate.getDate() + totalDays);

  const now = new Date();
  const totalMs = slaDate.getTime() - lastUpdate.getTime();
  const elapsedMs = now.getTime() - lastUpdate.getTime();
  const percentage = (elapsedMs / totalMs) * 100;

  if (percentage >= 100) return "danger"; // Atrasado ou vencendo
  if (percentage >= 75) return "warning"; // 75% do tempo já passou
  return "safe"; // Ainda tem tempo
};
